export default __webpack_public_path__ + "static/media/img_company_header3.bf204dc0.png";